export default {
    path: 'dashboard',
    name: "DashBoardIndex",
    component: () => import(/* webpackChunkName: "login" */ '@/pages/dashboard/Index'),
    meta: { title: '仪表盘' },
}
